import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditSecondaryCriteriaTemplateRequestFailure(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isFailure : false;
    },
    isEditSecondaryCriteriaTemplateRequestPending(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isPending : false;
    },
    isEditSecondaryCriteriaTemplateRequestSuccess(namespace, type) {
      const req = getState().find(
        (req) => req.type === type && req.namespace === namespace,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
